<template>
  <div class="page padding">
    <!--  -->
    <b-card no-body>
      <div class="p-3">
        <h4 class="mb-1">
          {{ nombreProductor }}
          <br />
          <small>Nomina de Asegurados</small>
        </h4>
      </div>      
      <b-row class="p-3">        
        <b-col sm="10">
        <!-- <b-col sm="5"> -->
          <label class="mr-2">Productor</label>
          <v-select
            id="type-select"
            class="mb-2 mr-sm-2 mb-sm-0"
            v-model="payload.producer"
            :options="productores"
            label="text"
            :disabled="$role(['productor'])"
          ></v-select>          
        </b-col>        
        <b-col rounded opacity="0.6" spinner-small spinner-variant="primary" class="d-inline-block" style="margin-top: 26px" sm="2">
          <b-btn class="btn-action" variant="primary" :disabled="loading" @click="fetchResults"> Aceptar </b-btn>
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body v-if="results.length && !loading"> 
        <b-row>          
          <b-col sm="10">
            <div class="alert alert-success mt-1 ml-1" role="alert">
              Estos resultados son en base a pólizas vigentes hasta el día de la fecha
            </div>
        </b-col>
        <b-col sm="2"><b-button class="btn-success m-2" @click="exportarShow">Exportar...</b-button></b-col>
      </b-row>               
        <b-table
            :items="results"
            :fields="columns.map(x => x.checked?x:null).filter(y => y!==null)"
            :per-page="perPage"
            :current-page="currentPage"
            style="margin-bottom:0;"
            responsive 
            striped     
            />    
            <b-card-footer>
                <b-row align-v="center">
                    <b-col>{{ registros }} de {{ results.length }} resultados</b-col>
                    <b-col> 
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="results.length"
                            :per-page="perPage"
                            aria-controls="my-table"
                        ></b-pagination>
                    </b-col>
                    <b-col></b-col>
                </b-row>
            </b-card-footer>            
    </b-card>
    <b-modal id="exportar-modal" title="Exportar" hide-footer>
      <label for="report-select" class="my-2">Formato de reporte:</label>
      <b-select id="report-select" class="mb-2 mr-sm-2 mb-sm-0" v-model="formato" 
                :options="opcionesExport">            
      </b-select>
      <p class="my-2">Propiedades a mostar en el reporte:</p>
      <b-form-checkbox-group class="ml-5" v-model="reportCols" v-for="(col, index) in columns" :key="index">                
        <b-form-checkbox class="mb-1" :value="col.key">{{col.label}}</b-form-checkbox>                
      </b-form-checkbox-group>
      <hr>
      <b-button id="exportararchivoButton" variant="success" @click="exportTo()" :disabled="exporting">Exportar Reporte</b-button>
    </b-modal>
  </div>
    <!--  -->  
</template>

<script>
import downloadDatatable from '@/helpers/download-datatable';
export default {
  data() {
    return {
      loading: false,
      exporting: false,
      currentPage: 1,
      perPage: 10,
      opcionesExport: [{text:'PDF', value:'pdf'}, {text:'CSV', value:'csv'}, {text:'XLS', value:'xls'}],
      results: [],
      columns: [{
                    key: 'cod_aseg',
                    label: 'Cod Asegurado',
                    checked: false
                },
                {
                    key: 'ASEGURADO',
                    label: 'Asegurado',
                    checked: true
                },
                {
                    key: 'Tipo de Documento',
                    label: 'Tipo de Documento',
                    checked: true
                },
                {
                    key: 'nro_doc',
                    label: 'Nro Documento',
                    checked: true
                },
                {
                    key: 'DIR',
                    label: 'Direccion',
                    checked: false
                },
                {
                    key: 'cp',
                    label: 'Codigo Postal',
                    checked: false
                },
                {
                    key: 'localidad',
                    label: 'Localidad',
                    checked: false
                },
                {
                    key: 'provincia',
                    label: 'Provincia',
                    checked: false
                },
                {
                    key: 'email',
                    label: 'E-Mail',
                    checked: true
                },
                {
                    key: 'telefono',
                    label: 'Telefono',
                    checked: false
                }
                
      ],
      formato: 'pdf',
      reportCols: [],
      payload: {
                producer: null
               }
    };
  },
  computed: {
    nombreProductor() {
      return this.$store.getters['NOMBRE_PRODUCTOR'];
    },  
    registros(){
      return (this.perPage * this.currentPage < this.results.length)?(this.perPage * this.currentPage):this.results.length;
    },
    productores(){
        if (this.$role(['productor'])){
            let obj = {text: this.$store.getters['NOMBRE_PRODUCTOR']+' - '+this.$store.state.auth.cod_agente,
                       value: this.$store.state.auth.cod_agente};
            this.payload.producer = obj;
            return [obj];
        }else
        return this.$store.getters['productoresCartera']
    }
  },
  methods: {    
    async fetchResults() {      
      if (!this.payload.producer){
          this.$toast.error('Seleccione un productor para poder continuar.');
          return;
      }

      this.loading = true;
      let loadScreen = this.$loading.show();
      this.$api.post('recursos/nomina-asegurados',
                    {cod_agente: this.payload.producer.value})
          .then(r => {
              this.results = r.data;
              this.loading = false;
              loadScreen.hide();
              if (this.results.length == 0) this.$toast.warning('La consulta no contiene resultados.', 'Atencion');
          })
    },

    exportarShow(){
        this.reportCols = this.columns.map(x => x.checked?x.key:null).filter(y => y != null);
        this.$bvModal.show('exportar-modal');
    },
    
    exportTo(){
        this.exporting = true;
        if (this.formato == 'xls'){
          let loading = this.$loading.show();
          this.$api({
            method: 'POST',
            url: 'recursos/nomina-asegurados',
            data: {cod_agente: this.payload.producer.value,
                   formato: this.formato,
                   cols: this.reportCols
                  },
            responseType: 'blob',
            headers: {
                      ContentType: 'multipart/form-data',
                    }})
          .then(r => {
              const fileURL = URL.createObjectURL(r.data);
              const link = document.createElement('a');
              link.setAttribute('href', encodeURI(fileURL));
              link.setAttribute('download', 'nomina-asegurados.xls');
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              loading.hide();
          });
        }else
          downloadDatatable(this.results, this.columns.filter(x => this.reportCols.includes(x.key)), 'nomina-asegurados.'+this.formato);
        this.$bvModal.hide('exportar-modal');
        this.exporting = false;
    }
  },
}
</script>
